<script lang="ts">
	import { CONTACT_PHONE } from '$lib/contact';

	// Keeping the original "expanded" desktop button stuff commented out in here
	// incase we want to re-enable it at some point
</script>

<div id="viewport-call-to-action">
	<div class="text-center">
		<a
			href="tel:{CONTACT_PHONE.number}"
			class="btn btn-dark btn-square btn-lg btn-block btn-default"
		>
			<i class="fa-solid fa-phone pr-5 icon" />
			<!-- <span class="show-hover">Call Us</span> -->
		</a>
		<a
			href="/contact#schedule-estimate"
			class="btn btn-dark btn-square btn-lg btn-block btn-default"
		>
			<i class="fa-regular fa-calendar-check pr-5 icon" />
			<!-- <span class="hidden-xs">Schedule Estimate</span> -->
		</a>
	</div>
</div>

<style lang="scss">
	@import 'src/lib/scss/colors';

	#viewport-call-to-action {
		opacity: 1;
		z-index: 999;
		position: fixed;
		right: 30px;
		bottom: 20px;

		.btn {
			font-size: 16px;
			display: block;
			margin-bottom: 20px;
			background-color: $green;
			border-color: $green;

			&:last-child {
				margin-bottom: 0px;
			}

			&:hover {
				background-color: #212121;
				color: #eeeeee;
			}
		}
	}

	// Used to only show circle buttons on mobile
	// @media (max-width: 766px) {
	#viewport-call-to-action {
		right: 10px;

		.btn {
			border-radius: 50%;
			height: 80px;
			width: 80px;
			padding: 26px;

			.icon {
				font-size: 24px;
				margin: 0px;

				&.fa-calendar-check {
					font-size: 26px;
				}
			}
		}
	}
	// }
</style>
